module.exports = __webpack_public_path__ + "img/placeholder-client-program.472ea829.jpg";